/**
 * Template for the Game Observer loader/sync overlay only.
 * Renders inside a provided container. No HUD markup.
 */
module.exports = function () {
  return "\n    <div id=\"observer-sync-overlay\" class=\"game-observer-sync-overlay\">\n      <div class=\"game-observer-sync-title\">Initializing Observer Mode...</div>\n      <div class=\"game-observer-inline-spinner\"></div>\n      <div id=\"observer-sync-status\" class=\"game-observer-sync-status\">\n        Checking archive for game transactions...\n      </div>\n    </div>\n  ";
};